import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
    Row,
    Col,
    Card,
    Icon
} from 'design-react-kit';
import { ListingLinkMore } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { useHistory } from 'react-router-dom';
import unibalogo from '../../theme/images/unibalogo.svg';

const StrutturaTemplate = ({
    items,
    title,
    isEditMode,
    linkAlign,
    linkTitle,
    linkHref,
    titleLine,
    linkmore_id_lighthouse,
}) => {
    const intl = useIntl();
    const history = useHistory();
    const alt_vai_struttura = intl.formatMessage({ id: 'goStructureAlt' });
    const intl_goStructure = intl.formatMessage({ id: 'goStructure' });
    const intl_goStructureWebsite = intl.formatMessage({ id: 'goStructureWebsite' });
    const intl_goStructureParent = intl.formatMessage({ id: 'goStructureParent' });
    const intl_goStructureMail = intl.formatMessage({ id: 'goStructureMail' });
    return (
        <section className="strutture-search-results" aria-label={intl.formatMessage({ id: 'structureResultsAlt' })}>
            {title && (
                <Row>
                    <Col>
                        <h2
                            className={cx('mb-4', {
                                'mt-5': !show_block_bg,
                                'title-bottom-line': titleLine,
                            })}
                        >
                            {title}
                        </h2>
                    </Col>
                </Row>
            )}
            <div className="strutture-search-results-cards-wrapper mb-3">
                <Row>
                    {items.map((item, index) => {
                        let struttura_url = item['@id'];
                        if (
                            struttura_url.startsWith('http://') ||
                            struttura_url.startsWith('https://') ||
                            struttura_url.startsWith('//')
                        ) {
                            const urlObj = new URL(struttura_url);
                            struttura_url = urlObj.pathname + urlObj.search + urlObj.hash;
                        }
                        const strutt_title = item.Title || item.title;
                        const parent_type = item?.parent?.['@type'] ?? null;
                        const parent_title = item?.parent?.['title'] ?? null;
                        let parent_url = item?.parent?.['@id'] ?? null;
                        if (
                            typeof parent_url === 'string' &&
                            (
                                parent_url.startsWith('http://') ||
                                parent_url.startsWith('https://') ||
                                parent_url.startsWith('//')
                            )
                        ) {
                            const urlObj = new URL(parent_url);

                            const segments = urlObj.pathname.split('/').filter(Boolean);
                            const cleanedPath = '/' + segments.slice(1).join('/');

                            parent_url = cleanedPath + urlObj.search + urlObj.hash;
                        }
                        const parent_title_alt = `${intl_goStructureParent} ${parent_title}`;
                        const website_alt = `${intl_goStructureWebsite} ${strutt_title}`;
                        const mail_alt = `${intl_goStructureMail} ${strutt_title}`;
                        return (
                            <Col key={item['@id']} xs={12} md={6} lg={4} className="">
                                <Card
                                    className={cx('listing-item shadow', item['review_state'])}
                                    role="region"
                                    aria-labelledby={`card-title-${index}`}
                                >
                                    <div className="strutture-title my-4 position-relative d-flex align-items-center px-2">
                                        <img
                                            src={unibalogo}
                                            className="position-absolute strutture-logo"
                                            aria-hidden="true"
                                        />

                                        <h5
                                            id={`card-title-${index}`}
                                            role="heading"
                                            aria-level="3"
                                            className="mb-0 strutture-name py-2 fs-4 lh-1 d-flex align-items-center">
                                            <span className="d-inline-block">{strutt_title}</span>
                                        </h5>
                                    </div>
                                    <div className="strutture-info px-4">
                                        {parent_type === 'Struttura' && parent_title && (
                                            <div className="struttura-parent d-flex z-3 position-relative align-items-center w-fit-content">
                                                <Icon icon="it-pa" size="sm" aria-hidden="true" className="pe-2 flex-shrink-0" />
                                                <a
                                                    href={parent_url}
                                                    onClick={(e) => e.stopPropagation()}
                                                    aria-label={parent_title_alt}
                                                    title={parent_title_alt}
                                                >
                                                    {parent_title}
                                                </a>
                                            </div>
                                        )}
                                        {item.email ? (
                                            <div className="mail d-flex z-3 position-relative align-items-center w-fit-content">
                                                <Icon icon="it-mail" size="sm" aria-hidden="true" className="pe-2 flex-shrink-0" />
                                                <a
                                                    href={`mailto:${item.email}`}
                                                    onClick={(e) => e.stopPropagation()}
                                                    aria-label={mail_alt}
                                                    title={mail_alt}
                                                >
                                                    {item.email}
                                                </a>
                                            </div>
                                        ) : null}
                                        {item.sitoweb ? (
                                            <div className="sitoweb d-flex z-3 position-relative align-items-center w-fit-content">
                                                <Icon icon="it-external-link" size="sm" aria-hidden="true" className="pe-2 flex-shrink-0" />
                                                <a
                                                    href={`${item.sitoweb}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(e) => e.stopPropagation()}
                                                    aria-label={website_alt}
                                                    title={website_alt}
                                                >
                                                    {item.sitoweb}
                                                </a>
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="strutture-link-container d-flex justify-content-end p-2">
                                        <a
                                            href={struttura_url}
                                            aria-label={`${intl_goStructure} : ${strutt_title}`}
                                            title={`${alt_vai_struttura}: ${strutt_title}`}
                                            className="strutture-link d-flex align-items-center p-2 w-fit-content stretched-link d-flex flex-row"
                                            onClick={
                                                (e) => {
                                                    e.preventDefault();
                                                    history.push(struttura_url);
                                                }
                                            }
                                        >
                                            <span>{intl_goStructure}</span>
                                            <Icon
                                                icon="it-arrow-right"
                                                size="sm"
                                                aria-hidden="true"
                                                className="ms-2"
                                            />
                                        </a>
                                    </div>

                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>

            <ListingLinkMore
                title={linkTitle}
                href={linkHref}
                linkAlign={linkAlign}
                className="my-4"
                linkmoreIdLighthouse={linkmore_id_lighthouse}
            />
        </section>
    );
};



StrutturaTemplate.propTypes = {
    items: PropTypes.arrayOf(PropTypes.any).isRequired,
    linkTitle: PropTypes.any,
    linkHref: PropTypes.any,
    title: PropTypes.string,
};

export default StrutturaTemplate;
